import { api } from "AurionCR/components"

export const getDynamicMaxRank = async (url: string) => {
  const params = {
    take: 1,
    orderBy: "rank desc",
  }
  const {
    data: { value },
  } = await api.post<{ value: { rank: number }[] }>(url, { params })

  const rank = value[0] ? value[0].rank : 0

  return rank + 1
}
